import { defineComponent as C, useAttrs as B, computed as a, ref as _, inject as z, openBlock as u, createElementBlock as c, normalizeClass as N, unref as m, withDirectives as S, createElementVNode as V, mergeProps as A, vModelCheckbox as E, renderSlot as q, createCommentVNode as w } from "vue";
import { CheckboxSizes as l, CheckboxGroupSymbol as D } from "./novoui-vuejs52.js";
const P = ["value", "disabled", "indeterminate"], $ = {
  key: 0,
  class: "checkbox-label"
}, I = /* @__PURE__ */ C({
  inheritAttrs: !1,
  __name: "NCheckbox",
  props: {
    size: {
      type: String,
      default: l.medium
    },
    modelValue: {
      type: [String, Number, Boolean, Array],
      required: !1,
      default: void 0
    },
    value: {
      type: [String, Number, Boolean],
      required: !1,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    indeterminate: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:model-value"],
  setup(p, { expose: b, emit: f }) {
    const { class: h, ...k } = B(), x = f, s = a({
      get: () => e.modelValue,
      set: (o) => x("update:model-value", o)
    }), r = _();
    b({ value: r });
    const t = z(D, {}), e = p, n = a(() => t.disabled || e.disabled), v = a(() => t.indeterminate ?? e.indeterminate), y = a(() => {
      switch (t.size ?? e.size) {
        case l.medium:
          return "checkbox-md";
        case l.large:
          return "checkbox-lg";
        default:
          return "";
      }
    });
    return (o, d) => {
      var i;
      return u(), c("label", {
        class: N([
          "checkbox checkbox-primary",
          y.value,
          m(h),
          {
            "checkbox-alert": ((i = m(t)) == null ? void 0 : i.error) ?? e.error,
            "checkbox-disabled": n.value
          }
        ])
      }, [
        S(V("input", A({
          class: "checkbox-input",
          type: "checkbox",
          ref_key: "checkboxExposed",
          ref: r,
          value: e.value,
          disabled: n.value,
          indeterminate: v.value,
          "onUpdate:modelValue": d[0] || (d[0] = (g) => s.value = g)
        }, k), null, 16, P), [
          [E, s.value]
        ]),
        o.$slots.default ? (u(), c("span", $, [
          q(o.$slots, "default")
        ])) : w("", !0)
      ], 2);
    };
  }
});
export {
  I as default
};
